import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDirectivesSrcErrorModule } from '@fantaz/shared/directives/src-error';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';
import {
  FzGameCardPrizeComponent,
  FzGameCardPrizeDescriptionComponent,
  FzGameCardTagsComponent,
  FzGameCardTimeComponent,
  FzGameCardTypeComponent,
  GameCardComponent,
} from './game-card.component';

const GAME_CARD_DIRECTIVES = [
  FzGameCardPrizeDescriptionComponent,
  FzGameCardPrizeComponent,
  FzGameCardTimeComponent,
  FzGameCardTypeComponent,
  FzGameCardTagsComponent,
  GameCardComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedDirectivesSrcErrorModule,
    CurrencyModule,
  ],
  declarations: [GAME_CARD_DIRECTIVES],
  exports: [GAME_CARD_DIRECTIVES],
})
export class GameCardModule {}
